<template>
  <v-app-bar app style="align-items: center;" :color="backgroundColor" :dark="dark" v-if="!$vuetify.breakpoint.mdAndUp">

    <v-toolbar-title class="chatbot-title">{{ chatbotName }}</v-toolbar-title>

    <v-spacer></v-spacer>

    <v-btn icon @click="returnHome()">
      <v-icon>mdi-sync</v-icon>
    </v-btn>

    <v-menu offset-y bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon class="hidden-md-and-up" v-bind="attrs" v-on="on">
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-list-item @click="showRecentChats">
        <v-list-item-content>
          <v-list-item-title><v-icon left class="mr-3">mdi-history</v-icon>Recent Chats</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="returnHome">
        <v-list-item-content>
          <v-list-item-title><v-icon left class="mr-3">mdi-sync</v-icon>Refresh Chat</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
  </v-app-bar>

</template>

<script>
export default {
  name: "chatBotHeader",
  props: {
    chatbotName: { type: String, required: true },
    backgroundColor: { type: String, required: true },
    dark: { type: Boolean, required: true },
    id_chatbot: { type: String, required: true },
    userRefSessionId: { type: String, required: true }
  },
  data() {
    return {
    };
  },
  methods: {
    returnHome() {
      window.location.href = 'https://ai.chatpro.pro/' + this.id_chatbot
    },
    showRecentChats() {
      this.$router.push('/recentChats/'+ this.id_chatbot + '?session_ref=' + this.userRefSessionId);
    }
  },
  watch: {
  },
};
</script>

<style scoped>
.chatbot-title {
  font-weight: 500;
  letter-spacing: -0.5px;
}
</style>
